module.exports = __webpack_public_path__ + "static/media/chat_coming_soon.e4f04f0f.png";